import * as React from 'react'

export const SvgAccountProfileOutline = (
  props: React.SVGProps<SVGSVGElement>,
) => (
  <svg viewBox="0 0 24 24" aria-hidden={true} {...props}>
    <path d="M4.5 17a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm16.5.5v2H8v-2h13zM4.5 11a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm16.5.5v2H8v-2h13zM4.5 5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm16.5.5v2H8v-2h13z" />
  </svg>
)
export default SvgAccountProfileOutline
